export default {"src":"/_next/static/media/arrow_left.9d7a8b62.svg","height":11,"width":18};